/// <summary>
/// This object provides js functions for ... <br/>
/// <br/>
/// Author: ARF<br />
/// Date: 20.9.2022<br />
/// Copyright ©: EUDT GmbH 2022 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 20.9.2022                                               *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>
jQuery.widget("bluaul.FullSubsignal", $.bluaul.vcMenuTemplate, {
   
   
    _create: function () {
        var me = this;
        try {
            me.element.html("");
            me.options.invoke.vcvid = 343;
            me.options.invoke.vcgid = Math.floor(Math.random() * Math.floor(1000000));
            me._super();
          
        } catch (e) { me.writeError('_create', e); return false;}
        return true;
    },


    _initVariables: function () {
        var me = this;
        try {
            me._super();

            me.settings.defaultChart = "subsignal";
            me.settings.menu.top.showMenuAsDropdown = false;
            me.settings.menu.top.interval.default = 1;
            me.settings.toggleView = true;
            me.settings.signalSelection = true;
            me.settings.showSignalsInContent = true;
            me.settings.showAllSignalsAtStart = true;
            me.settings.enableFilterForInvalidSignals = true;
            me.settings.hideSignalsWithNotAllowedSettings = true;
            me.settings.showArchiveRules = false;
            me.settings.enableMeta = false;

            me.settings.menu.top.showHeaders = true;
            me.settings.menu.top.interval.enabled = true;
            me.settings.menu.top.charts.enabled = false;
            me.settings.menu.top.datatype.showAccumulated = false;
            me.settings.menu.top.datatype.showSingleValueAsConsumption = false;
            me.settings.menu.top.datatype.showFill0 = false;
            me.settings.menu.top.datatype.showAddTemp = false;
            me.settings.menu.top.datatype.showPrice = true;
            me.settings.menu.top.datatype.showCo2 = false;
            me.settings.menu.top.datatype.showDetails = false;
            me.settings.menu.top.datatype.showDataCenter = false;

            me.settings.menu.top.opt.enabled = false;
            me.settings.menu.top.opt.showTags = false;
            me.settings.menu.top.opt.showRules = false;
            me.settings.menu.top.opt.showInterventions = false;
            me.settings.menu.top.opt.showTickets = false;
            me.settings.menu.top.export.enabled = true;
            me.settings.menu.top.export.showFavorites = false;
            me.settings.menu.top.export.showShare = true;

            me.settings.menu.main.button.enabled = true;
            me.settings.menu.main.button.showTakeBtnOnly = false;
            me.settings.menu.main.date.enabled = true;
            me.settings.menu.main.dateComparison.enabled = false;
            me.settings.menu.main.rampResolution.enabled = false;
            me.settings.menu.main.rampOptions.enabled = false;
            me.settings.menu.main.rampTempCharts.enabled = false;
            me.settings.menu.main.specificOptions.enabled = false;
            me.settings.menu.main.history.enabled = true;

            me.settings.selection.choice.enabled = true;
            me.settings.selection.entries.button.enabled = false;
            me.settings.selection.entries.signals.showIcons = false;

            me.settings.subvisual.content.signalSelection = true;

        } catch (e) {
            me.writeError('_initVariables', e);
            return false;
        }
        return true;
    },


    _addAdditionalChartsToSettings: function () {
        var me = this;
        try {

            me._super();

            $.each(me.settings.charts, function () { this.enabled = false });
            me.settings.charts.filter(function (item) { return item.id == "subsignal" })[0].enabled = true;
            $.each(me.settings.iconCharts, function () { this.enabled = false });

        } catch (e) {
            me.writeError('_addAdditionalChartsToSettings', e);
            return false;
        }
        return true;
    },


    _loadSubvisualContent: function (contentStatus) {
        var me = this;
        if (!me.error) { me._initSubvisualContent(contentStatus); }
    },


    _loadSubvisualFromChoiceList: function (status) {
        var me = this;
        try {

            if (!me.error) {


                var param = JSON.stringify({ loggerid: me.specific.LoggerId, interval: status.menu.interval, datatype: 2, startDate: status.menu.startDate, endDate: status.menu.endDate, usePrices: status.menu.usePrice, dateUserDef: true, isArchive: true });
                var signalParam = JSON.stringify({ "signalID": status.subvisual.selectedBsaid });

                status.signals.shareParameter = {
                    'info': { bsaid: status.subvisual.selectedBsaid, name: '', description: '', startDate: status.menu.startDate, endDate: status.menu.endDate, dateUserDef: status.date.isSingle == false, interval: status.menu.interval },
                    'visualname': "VC_CHART_SUBSIGNALS", 'parameter': param, 'signalparameter': signalParam
                };

                //we have to make a new random container
                var cont = me.getRandomIDContainerObj("my-content-", true);

                me.vcMenu.subvisual.content.html(cont.obj);
                cont.obj.height(status.subvisual.content.height);
                cont.obj.width(status.subvisual.content.width);

                me.vcV.addRampBaseByName(cont.prefix, "VC_CHART_SUBSIGNALS", cont.random, getCurrentTimestamp(), cont.obj.height(), cont.obj.width(), param, signalParam, me.settings.deviceType);

            }

        } catch (e) { me._writeErr(e); }


    },

});

